export default "__VITE_ASSET__geXLqj8j__"